var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "div",
        { staticClass: "filter-container" },
        [
          _c("el-input", {
            staticClass: "filter-item",
            staticStyle: { width: "200px" },
            attrs: { clearable: "", placeholder: "请输入门店名称" },
            model: {
              value: _vm.listQuery.name,
              callback: function($$v) {
                _vm.$set(_vm.listQuery, "name", $$v)
              },
              expression: "listQuery.name"
            }
          }),
          _vm._v(" "),
          _c("el-input", {
            staticClass: "filter-item",
            staticStyle: { width: "160px" },
            attrs: { clearable: "", placeholder: "请输入门店编号" },
            model: {
              value: _vm.listQuery.shopSn,
              callback: function($$v) {
                _vm.$set(_vm.listQuery, "shopSn", $$v)
              },
              expression: "listQuery.shopSn"
            }
          }),
          _vm._v(" "),
          _c(
            "el-button",
            {
              directives: [
                {
                  name: "permission",
                  rawName: "v-permission",
                  value: ["GET /admin/shop/list"],
                  expression: "['GET /admin/shop/list']"
                }
              ],
              staticClass: "filter-item",
              attrs: { type: "primary", icon: "el-icon-search" },
              on: { click: _vm.handleFilter }
            },
            [_vm._v("查找")]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.listLoading,
              expression: "listLoading"
            }
          ],
          attrs: {
            data: _vm.list,
            "element-loading-text": "正在查询中。。。",
            border: "",
            fit: "",
            "highlight-current-row": ""
          }
        },
        [
          _c("el-table-column", {
            attrs: {
              align: "center",
              label: "门店编号",
              prop: "shopNo",
              sortable: "",
              width: "140px"
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { align: "center", label: "门店名称", prop: "shopName" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              align: "center",
              label: "省",
              prop: "shopProvince",
              width: "100px"
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              align: "center",
              label: "城市",
              prop: "shopCity",
              width: "100px"
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              align: "center",
              label: "经销商",
              prop: "dealerName",
              width: "250px"
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              align: "center",
              label: "状态",
              prop: "deleted",
              width: "100px"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    scope.row.deleted == true
                      ? _c("span", { staticStyle: { color: "red" } }, [
                          _vm._v("已停用")
                        ])
                      : _c("span", [_vm._v("正常")])
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              align: "center",
              label: "导入时间",
              prop: "createTime",
              width: "160px"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("pagination", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.total > 0,
            expression: "total>0"
          }
        ],
        attrs: {
          total: _vm.total,
          page: _vm.listQuery.page,
          limit: _vm.listQuery.limit
        },
        on: {
          "update:page": function($event) {
            return _vm.$set(_vm.listQuery, "page", $event)
          },
          "update:limit": function($event) {
            return _vm.$set(_vm.listQuery, "limit", $event)
          },
          pagination: _vm.getList
        }
      }),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.textMap[_vm.dialogStatus],
            visible: _vm.dialogFormVisible
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogFormVisible = $event
            }
          }
        },
        [
          _c(
            "el-form",
            {
              ref: "dataForm",
              staticStyle: { width: "600px", "margin-left": "50px" },
              attrs: {
                rules: _vm.rules,
                model: _vm.dataForm,
                "status-icon": "",
                "label-position": "left",
                "label-width": "100px"
              }
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "门店名称", prop: "shopName" } },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.dataForm.shopName,
                      callback: function($$v) {
                        _vm.$set(_vm.dataForm, "shopName", $$v)
                      },
                      expression: "dataForm.shopName"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "门店编号", prop: "shopNo" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入DRM的门店编号" },
                    model: {
                      value: _vm.dataForm.shopNo,
                      callback: function($$v) {
                        _vm.$set(_vm.dataForm, "shopNo", $$v)
                      },
                      expression: "dataForm.shopNo"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "所属城市", prop: "shopCity" } },
                [
                  _c(
                    "el-select",
                    {
                      staticClass: "filter-item",
                      staticStyle: { width: "100%" },
                      attrs: { clearable: "", placeholder: "请选择所属城市" },
                      model: {
                        value: _vm.dataForm.shopCity,
                        callback: function($$v) {
                          _vm.$set(_vm.dataForm, "shopCity", $$v)
                        },
                        expression: "dataForm.shopCity"
                      }
                    },
                    _vm._l(_vm.citys, function(type) {
                      return _c("el-option", {
                        key: type.id,
                        attrs: { label: type.cityName, value: type.id }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "门店详细地址", prop: "shopAddress" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入门店详细地址" },
                    model: {
                      value: _vm.dataForm.shopAddress,
                      callback: function($$v) {
                        _vm.$set(_vm.dataForm, "shopAddress", $$v)
                      },
                      expression: "dataForm.shopAddress"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "负责人", prop: "shopLeader" } },
                [
                  _c(
                    "el-select",
                    {
                      staticClass: "filter-item",
                      staticStyle: { width: "100%" },
                      attrs: {
                        multiple: "",
                        filterable: "",
                        clearable: "",
                        placeholder: "请选择负责人"
                      },
                      model: {
                        value: _vm.dataForm.shopLeader,
                        callback: function($$v) {
                          _vm.$set(_vm.dataForm, "shopLeader", $$v)
                        },
                        expression: "dataForm.shopLeader"
                      }
                    },
                    _vm._l(_vm.users, function(type) {
                      return _c("el-option", {
                        key: type.id,
                        attrs: { label: type.userName, value: type.id }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "状态", prop: "deleted" } },
                [
                  _c(
                    "el-select",
                    {
                      staticClass: "filter-item",
                      staticStyle: { width: "100%" },
                      attrs: { clearable: "", placeholder: "请选择状态" },
                      model: {
                        value: _vm.dataForm.deleted,
                        callback: function($$v) {
                          _vm.$set(_vm.dataForm, "deleted", $$v)
                        },
                        expression: "dataForm.deleted"
                      }
                    },
                    _vm._l(_vm.deletedOptions, function(type) {
                      return _c("el-option", {
                        key: type.value,
                        attrs: { label: type.label, value: type.value }
                      })
                    }),
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.dialogFormVisible = false
                    }
                  }
                },
                [_vm._v("取消")]
              ),
              _vm._v(" "),
              _vm.dialogStatus == "create"
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.createData }
                    },
                    [_vm._v("确定")]
                  )
                : _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.updateData }
                    },
                    [_vm._v("确定")]
                  )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }